module.exports = __webpack_public_path__ + "static/img/productd_banner1@2x.1661d749.jpg";